module.exports = __webpack_public_path__ + "img/offers.8b7ea6f6.svg";